'use client';

import Script from 'next/script';

const optimizelyProjectID = process.env.NEXT_PUBLIC_OPTIMIZELY_PROJECT_ID;

export function OptimizelyScript() {
    return <Script id="optimizely-script" src={`https://cdn.optimizely.com/js/${optimizelyProjectID}.js`} />;
}
